export default __webpack_public_path__ + "2339c147a16a4b7d9b861dfc4cd61b50.svg";